import { render, staticRenderFns } from "./AssetSortForm.vue?vue&type=template&id=6702f149&"
import script from "./AssetSortForm.vue?vue&type=script&lang=js&"
export * from "./AssetSortForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetSortForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports